import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { LayoutModule } from "app/components/templates/layout/layout.module";
import { IconModule } from "app/components/atoms/icon/icon.module";
import { TranslateModule } from "@ngx-translate/core";
import { DetailOfferComponent } from "app/pages/detail-offer/detail-offer.component";
import { CorePipesModule } from "core/pipes/pipe.module";
import {
  NgbAccordionModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { NgSelectModule } from "@ng-select/ng-select";
import { QRCodeModule } from "angularx-qrcode";

const routes: Routes = [
  {
    path: "",
    component: DetailOfferComponent,
  },
];

@NgModule({
  declarations: [DetailOfferComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    LayoutModule,
    IconModule,
    TranslateModule,
    CorePipesModule,
    NgbTooltipModule,
    NgbAccordionModule,
    PerfectScrollbarModule,
    NgSelectModule,
    QRCodeModule,
  ],
})
export class DetailOfferModule {}
